import { render, staticRenderFns } from "./TableMusic.vue?vue&type=template&id=5ca28d76&scoped=true&"
import script from "./TableMusic.vue?vue&type=script&lang=js&"
export * from "./TableMusic.vue?vue&type=script&lang=js&"
import style0 from "./TableMusic.vue?vue&type=style&index=0&id=5ca28d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca28d76",
  null
  
)

export default component.exports